import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_BlankIntakeForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_BlankIntakeForm' className='file-pdf-document'>

            <div className='file-template'>


                <p className='w-750'>
                    <center><h3>INTAKE SCREENING</h3> </center>
                </p>


                <h3>IDENTIFYING INFORMATION:</h3>
                <table>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Date of Referral/Date of Screening:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtDateReferral' name='txtDateReferral' className='add-only' />  </td>
                        <td className='w-375'> <input type='date' id='txtDateScreening' name='txtDateScreening' className='add-only' />  </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Contact Type:</span>
                    <input type="checkbox" id="cbContactType_1" name="cbContactType_1" className='add-only' value="ContactType_1" />  Face &nbsp;
                    <input type="checkbox" id="cbContactType_2" name="cbContactType_2" className='add-only' value="ContactType_2" />  Home &nbsp;
                    <input type="checkbox" id="cbContactType_3" name="cbContactType_3" className='add-only' value="ContactType_3" />  Phone/ Telehealth &nbsp;
                    <input type="checkbox" id="cbContactType_4" name="cbContactType_4" className='add-only' value="ContactType_4" />  In-Clinic
                </p>

                <h3>TREATMENT HISTORY</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Are you currently receiving psychiatric services, professional counseling or psychotherapy elsewhere?</span>
                    <input type="radio" id="rbPsychotherapy_Yes" name="rbPsychotherapy" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbPsychotherapy_No" name="rbPsychotherapy" className='add-only' value="No" />  No &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you had previous psychotherapy?</span>
                    <input type="radio" id="rbPreviousPsychotherapy_No" name="rbPreviousPsychotherapy" className='add-only' value="No" />  No &nbsp;
                    <input type="radio" id="rbPreviousPsychotherapy_Yes" name="rbPreviousPsychotherapy" className='add-only' value="Yes" />  Yes &nbsp;,with (previous therapist's name/agency)

                    <input type="text" id="txtPreviousPsychotherapy_YesTherapistName" name="txtPreviousPsychotherapy_YesTherapistName" className='add-only' /> 
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Are you currently taking prescribed psychiatric medication (antidepressants or others)?</span>
                    <input type="radio" id="rbTakingPrescribedPsychiatricMedication_Yes" name="rbTakingPrescribedPsychiatricMedication" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbTakingPrescribedPsychiatricMedication_No" name="rbTakingPrescribedPsychiatricMedication" className='add-only' value="No" />  No &nbsp;
                </p>
                <p className='w-750'>
                    If yes, please list:
                    <textarea id="txtTakingPrescribedPsychiatricMedicationIfYesList" name="txtTakingPrescribedPsychiatricMedicationIfYesList" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Prescribed by:</span>
                    <textarea id="txtPrescribedBy" name="txtPrescribedBy" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are you currently on medication to manage a physical health concern?</span>
                    <input type="radio" id="rbPhysicalHealthConcern_Yes" name="rbPhysicalHealthConcern" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbPhysicalHealthConcern_No" name="rbPhysicalHealthConcern" className='add-only' value="No" />  No &nbsp;
                </p>
                <p className='w-750'>
                    If yes, please list:
                    <textarea id="txtPhysicalHealthConcernIfYesList" name="txtPhysicalHealthConcernIfYesList" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>How often do you engage recreational drug use?</span>
                    <input type="radio" id="rbEngageRecreationalDrugUse_Daily" name="rbEngageRecreationalDrugUse" className='add-only' value="Daily" />  Daily &nbsp;
                    <input type="radio" id="rbEngageRecreationalDrugUse_Weekly" name="rbEngageRecreationalDrugUse" className='add-only' value="Weekly" />  Weekly &nbsp;
                    <input type="radio" id="rbEngageRecreationalDrugUse_Monthly" name="rbEngageRecreationalDrugUse" className='add-only' value="Monthly" />  Monthly &nbsp;
                    <input type="radio" id="rbEngageRecreationalDrugUse_Rarely" name="rbEngageRecreationalDrugUse" className='add-only' value="Rarely" />  Rarely &nbsp;
                    <input type="radio" id="rbEngageRecreationalDrugUse_Never" name="rbEngageRecreationalDrugUse" className='add-only' value="Never" />  Never &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Do you smoke cigarettes or use other tobacco products?</span>
                    <input type="radio" id="rbSmokeCigarettes_Yes" name="rbSmokeCigarettes" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbSmokeCigarettes_No" name="rbSmokeCigarettes" className='add-only' value="No" />  No &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>How often do you consume alcoholic beverages?</span>
                    <input type="radio" id="rbConsumeAlcoholicBeverages_Daily" name="rbConsumeAlcoholicBeverages" className='add-only' value="Daily" />  Daily &nbsp;
                    <input type="radio" id="rbConsumeAlcoholicBeverages_Weekly" name="rbConsumeAlcoholicBeverages" className='add-only' value="Weekly" />  Weekly &nbsp;
                    <input type="radio" id="rbConsumeAlcoholicBeverages_Monthly" name="rbConsumeAlcoholicBeverages" className='add-only' value="Monthly" />  Monthly &nbsp;
                    <input type="radio" id="rbConsumeAlcoholicBeverages_Rarely" name="rbConsumeAlcoholicBeverages" className='add-only' value="Rarely" />  Rarely &nbsp;
                    <input type="radio" id="rbConsumeAlcoholicBeverages_Never" name="rbConsumeAlcoholicBeverages" className='add-only' value="Never" />  Never &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you had suicidal thoughts recently (within 24 hours)?</span>
                    <input type="radio" id="rbSuicidalThoughtsRecently_Frequently" name="rbSuicidalThoughtsRecently" className='add-only' value="Frequently" />  Frequently &nbsp;
                    <input type="radio" id="rbSuicidalThoughtsRecently_Sometimes" name="rbSuicidalThoughtsRecently" className='add-only' value="Sometimes" />  Sometimes &nbsp;
                    <input type="radio" id="rbSuicidalThoughtsRecently_Rarely" name="rbSuicidalThoughtsRecently" className='add-only' value="Rarely" />  Rarely &nbsp;
                    <input type="radio" id="rbSuicidalThoughtsRecently_Never" name="rbSuicidalThoughtsRecently" className='add-only' value="Never" />  Never &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you had them in the past 30 days?</span>
                    <input type="radio" id="rbSuicidalThoughtsRecentlyPastThirtyDays_Frequently" name="rbSuicidalThoughtsRecentlyPastThirtyDays" className='add-only' value="Frequently" /> Frequently &nbsp;
                    <input type="radio" id="rbSuicidalThoughtsRecentlyPastThirtyDays_Sometimes" name="rbSuicidalThoughtsRecentlyPastThirtyDays" className='add-only' value="Sometimes" /> Sometimes &nbsp;
                    <input type="radio" id="rbSuicidalThoughtsRecentlyPastThirtyDays_Rarely" name="rbSuicidalThoughtsRecentlyPastThirtyDays" className='add-only' value="Rarely" /> Rarely &nbsp;
                    <input type="radio" id="rbSuicidalThoughtsRecentlyPastThirtyDays_Never" name="rbSuicidalThoughtsRecentlyPastThirtyDays" className='add-only' value="Never" /> Never &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are you having any hallucinations?</span>
                    <input type="radio" id="rbHallucinations_Frequently" name="rbHallucinations" className='add-only' value="Frequently" /> Frequently &nbsp;
                    <input type="radio" id="rbHallucinations_Sometimes" name="rbHallucinations" className='add-only' value="Sometimes" /> Sometimes &nbsp;
                    <input type="radio" id="rbHallucinations_Rarely" name="rbHallucinations" className='add-only' value="Rarely" /> Rarely &nbsp;
                    <input type="radio" id="rbHallucinations_Never" name="rbHallucinations" className='add-only' value="Never" /> Never &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are you currently married or in a relationship?</span>
                    <input type="radio" id="rbCurrentlyMarried_Yes" name="rbCurrentlyMarried" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbCurrentlyMarried_No" name="rbCurrentlyMarried" className='add-only' value="No" />  No &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Do you currently have any open cases w/ the DOJ/DFCS or legal issues?</span>
                    <input type="radio" id="rbLegalIssues_Yes" name="rbLegalIssues" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbLegalIssues_No" name="rbLegalIssues" className='add-only' value="No" />  No &nbsp;
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Have you ever experienced any of the following?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>Extreme depressed mood </td>
                        <td className='w-375'>
                            <input type="radio" id="rbExtremeDepressedMood_Yes" name="rbExtremeDepressedMood" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbExtremeDepressedMood_No" name="rbExtremeDepressedMood" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Dramatic mood swings </td>
                        <td className='w-375'>
                            <input type="radio" id="rbDramaticMoodSwings_Yes" name="rbDramaticMoodSwings" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbDramaticMoodSwings_No" name="rbDramaticMoodSwings" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Rapid speech </td>
                        <td className='w-375'>
                            <input type="radio" id="rbRapidSpeech_Yes" name="rbRapidSpeech" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbRapidSpeech_No" name="rbRapidSpeech" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Extreme anxiety </td>
                        <td className='w-375'>
                            <input type="radio" id="rbExtremeAnxiety_Yes" name="rbExtremeAnxiety" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbExtremeAnxiety_No" name="rbExtremeAnxiety" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Panic attacks </td>
                        <td className='w-375'>
                            <input type="radio" id="rbPanicAttacks_Yes" name="rbPanicAttacks" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbPanicAttacks_No" name="rbPanicAttacks" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Phobias </td>
                        <td className='w-375'>
                            <input type="radio" id="rbPhobias_Yes" name="rbPhobias" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbPhobias_No" name="rbPhobias" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Sleep disturbances </td>
                        <td className='w-375'>
                            <input type="radio" id="rbSleepDisturbances_Yes" name="rbSleepDisturbances" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbSleepDisturbances_No" name="rbSleepDisturbances" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Hallucinations </td>
                        <td className='w-375'>
                            <input type="radio" id="rbHallucinations_Yes" name="rbHallucinations" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbHallucinations_No" name="rbHallucinations" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Unexplained losses of time </td>
                        <td className='w-375'>
                            <input type="radio" id="rbUnexplainedLossesTime_Yes" name="rbUnexplainedLossesTime" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbUnexplainedLossesTime_No" name="rbUnexplainedLossesTime" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Unexplained memory lapses </td>
                        <td className='w-375'>
                            <input type="radio" id="rbUnexplainedMemoryLapses_Yes" name="rbUnexplainedMemoryLapses" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbUnexplainedMemoryLapses_No" name="rbUnexplainedMemoryLapses" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Alcohol/substance abuse </td>
                        <td className='w-375'>
                            <input type="radio" id="rbAlcoholSubstanceAbuse_Yes" name="rbAlcoholSubstanceAbuse" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbAlcoholSubstanceAbuse_No" name="rbAlcoholSubstanceAbuse" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Frequent body complaints </td>
                        <td className='w-375'>
                            <input type="radio" id="rbFrequentBodyComplaints_Yes" name="rbFrequentBodyComplaints" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbFrequentBodyComplaints_No" name="rbFrequentBodyComplaints" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Eating disorder </td>
                        <td className='w-375'>
                            <input type="radio" id="rbEatingDisorder_Yes" name="rbEatingDisorder" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbEatingDisorder_No" name="rbEatingDisorder" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>Body image problems </td>
                        <td className='w-375'>
                            <input type="radio" id="rbBodyImageProblems_Yes" name="rbBodyImageProblems" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbBodyImageProblems_No" name="rbBodyImageProblems" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Repetitive thoughts (e.g. obsessions) </td>
                        <td className='w-375'>
                            <input type="radio" id="rbRepetitiveThoughts_Yes" name="rbRepetitiveThoughts" className='add-only' value="Yes" />  Yes &nbsp; /
                            <input type="radio" id="rbRepetitiveThoughts_No" name="rbRepetitiveThoughts" className='add-only' value="No" />  No &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Repetitive behaviors (e.g. frequent checking, hand washing)
                    <textarea id="txtRepetitiveBehaviors" name="txtRepetitiveBehaviors" className='add-only'></textarea>
                </p>




                <p className='w-750'>
                    <span className='eleHeader'>Are you committed to receiving services?</span>
                    <input type="radio" id="rbCommittedToReceivingServices_Yes" name="rbCommittedToReceivingServices" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbCommittedToReceivingServices_No" name="rbCommittedToReceivingServices" className='add-only' value="No" />  No &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are you hoping to achieve through NHBC?</span>
                    <textarea id="txtAchieveThroughNhbc" name="txtAchieveThroughNhbc" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Do you have any additional concerns that you would like to address?</span>
                    <textarea id="txtAdditionalConcerns" name="txtAdditionalConcerns" className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date of Assessment Appointment:</span></td>
                        <td className='w-375'><span className='eleHeader'>Location of Assessment:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="txtDateAssessmentAppointment" name="txtDateAssessmentAppointment" className='add-only' /> </td>
                        <td className='w-375'>
                            <input type="text" id="txtLocationAssessment" name="txtLocationAssessment" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date of Wellness Check:</span></td>
                        <td className='w-375'><span className='eleHeader'>Assigned Assessor:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="txtDateWellnessCheck" name="txtDateWellnessCheck" className='add-only' /> </td>
                        <td className='w-375'>
                            <input type="date" id="txtAssignedAssessor" name="txtAssignedAssessor" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Diagnostic Impression/Diagnosis Rendered:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtDiagnosticImpressionDiagnosisRendered" name="txtDiagnosticImpressionDiagnosisRendered" className='add-only' /> </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Assessor's Signature/Credentials:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>

            </div>
        </form>

    )
} 
